import { Navigate } from 'react-router-dom'
import signInAction from '../../actions/signInAction'
import getSubscriptionsLoader from '../../loaders/getSubscriptionsLoader'
import { downloadRedirectLoader } from '../../pages/DownloadRedirectPage'
import ForgotPasswordPage from '../../pages/account/ForgotPasswordPage'
import ResetPasswordPage from '../../pages/account/ResetPasswordPage'
import SignInPage from '../../pages/account/SignInPage'
import SubscriptionPage from '../../pages/account/SubscriptionPage'

const createAccountRoutes = () => [
  {
    index: true,
    element: <Navigate to="subscription" replace />,
  },
  {
    loader: downloadRedirectLoader,
    path: 'download',
  },
  {
    element: <ForgotPasswordPage />,
    path: 'forgot-password',
  },
  {
    element: <ResetPasswordPage />,
    path: 'reset-password',
  },
  {
    action: signInAction,
    element: <SignInPage />,
    path: 'sign-in',
  },
  {
    element: <SubscriptionPage />,
    loader: getSubscriptionsLoader,
    path: 'subscription',
  },
]

export default createAccountRoutes
